import { Discount, DiscountType, DiscountValueType } from "@hubcapp/types";

import { AreaDiscountRowData } from "./types";

export const mapDiscountsToTableData = (
  instructorDiscounts: (Discount | null)[],
  allDiscounts: Discount[],
): AreaDiscountRowData[] =>
  allDiscounts.map(discount => {
    const hasDiscount = instructorDiscounts.some(
      instructorDiscount => instructorDiscount?.id === discount.id,
    );
    return {
      ...discount,
      tableData: { checked: hasDiscount },
    };
  });

export const badgeColorForDiscountType = (
  type: DiscountType,
): "root" | "primary" | "secondary" | "error" | "success" | "warning" =>
  type === DiscountType.ExistingLearner ? "success" : "warning";

const discountLabelMap: Record<DiscountType, string> = {
  [DiscountType.ExistingLearner]: "Existing Learner",
  [DiscountType.NewLearner]: "New learner",
};

export const labelForDiscountType = (type: DiscountType): string =>
  discountLabelMap[type];

export const formatValue = (value: number, type: DiscountValueType) =>
  type == DiscountValueType.Percentage
    ? (value * 100).toString() + "%"
    : "£" + value.toString() + " /hr";
